import { components, NoticeProps, GroupBase } from 'react-select'

import styles from './NoOptionsMessage.module.scss'

export const NoOptionsMessage = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: NoticeProps<Option, IsMulti, Group>
) => <components.NoOptionsMessage {...props} className={styles.root} />
